module.exports = __webpack_public_path__ + "static/img/stop.7a9594a0.svg";